import {useCallback, useEffect, useRef, useState} from "react";

import {useElementWasVisible} from "@pg-mono/hooks";

import {IOfferListOffer} from "../../../offer/types/IOfferListOffer";
import {PricesCityAnalyticsLocation} from "../tracking/prices_city_analytics";
import {trackPricesCityOffersViewItemList} from "../tracking/track_prices_city_offers_view_item_list";

interface IUsePricesCityOffersViewItemListTrackingParams {
    offers: IOfferListOffer[];
    itemListId?: string;
    location?: PricesCityAnalyticsLocation;
    /** While the district filter is still loading, the offers on screen belong to the previous filter. */
    isFetching: boolean;
}

const CAROUSEL_VISIBILITY_THRESHOLD = 0.5;
const CAROUSEL_ELEMENT_ID = "prices-city-offers-carousel";

export const usePricesCityOffersViewItemListTracking = (params: IUsePricesCityOffersViewItemListTrackingParams) => {
    const {offers, itemListId, location, isFetching} = params;
    const carouselRef = useRef<HTMLDivElement | null>(null);
    const trackedContextKeyRef = useRef<string | null>(null);
    const [wasCarouselVisible, setWasCarouselVisible] = useState(false);
    const offerIds = offers.map(({id}) => id).join(",");

    // the observer keeps the callback it was mounted with, so visibility only flips state - the effect below reads the current offers
    const handleCarouselVisible = useCallback(() => setWasCarouselVisible(true), []);

    useElementWasVisible({
        ids: [],
        elementRefs: [{id: CAROUSEL_ELEMENT_ID, ref: carouselRef}],
        onElementVisible: handleCarouselVisible,
        once: true,
        threshold: CAROUSEL_VISIBILITY_THRESHOLD
    });

    useEffect(() => {
        if (!location || !wasCarouselVisible || isFetching || offers.length === 0) {
            return;
        }

        const contextKey = `${itemListId ?? ""}|${location}|${offerIds}`;

        if (trackedContextKeyRef.current === contextKey) {
            return;
        }

        trackedContextKeyRef.current = contextKey;
        trackPricesCityOffersViewItemList({offers, itemListId, location});
    }, [wasCarouselVisible, isFetching, itemListId, location, offerIds, offers]);

    return carouselRef;
};
import {useCallback, useEffect, useRef, useState} from "react";

import {useElementWasVisible} from "@pg-mono/hooks";

import {IOfferListOffer} from "../../../offer/types/IOfferListOffer";
import {PricesCityAnalyticsLocation} from "../tracking/prices_city_analytics";
import {trackPricesCityOffersViewItemList} from "../tracking/track_prices_city_offers_view_item_list";

interface IUsePricesCityOffersViewItemListTrackingParams {
    offers: IOfferListOffer[];
    itemListId?: string;
    location?: PricesCityAnalyticsLocation;
    /** While the district filter is still loading, the offers on screen belong to the previous filter. */
    isFetching: boolean;
}

const CAROUSEL_VISIBILITY_THRESHOLD = 0.5;
const CAROUSEL_ELEMENT_ID = "prices-city-offers-carousel";

export const usePricesCityOffersViewItemListTracking = (params: IUsePricesCityOffersViewItemListTrackingParams) => {
    const {offers, itemListId, location, isFetching} = params;
    const carouselRef = useRef<HTMLDivElement | null>(null);
    const trackedContextKeyRef = useRef<string | null>(null);
    const [wasCarouselVisible, setWasCarouselVisible] = useState(false);
    const offerIds = offers.map(({id}) => id).join(",");

    // the observer keeps the callback it was mounted with, so visibility only flips state - the effect below reads the current offers
    const handleCarouselVisible = useCallback(() => setWasCarouselVisible(true), []);

    useElementWasVisible({
        ids: [],
        elementRefs: [{id: CAROUSEL_ELEMENT_ID, ref: carouselRef}],
        onElementVisible: handleCarouselVisible,
        once: true,
        threshold: CAROUSEL_VISIBILITY_THRESHOLD
    });

    useEffect(() => {
        if (!location || !wasCarouselVisible || isFetching || offers.length === 0) {
            return;
        }

        const contextKey = `${itemListId ?? ""}|${location}|${offerIds}`;

        if (trackedContextKeyRef.current === contextKey) {
            return;
        }

        trackedContextKeyRef.current = contextKey;
        trackPricesCityOffersViewItemList({offers, itemListId, location});
    }, [wasCarouselVisible, isFetching, itemListId, location, offerIds, offers]);

    return carouselRef;
};
